import type { ReactNode } from "react";
import { SITE_OG_IMAGE } from "@/lib/seo";
import { Link } from "@tanstack/react-router";

export function StaticPage({
  title,
  intro,
  children,
}: {
  title: string;
  intro?: string;
  children: ReactNode;
}) {
  return (
    <div>
      <nav className="mx-auto max-w-3xl px-4 sm:px-6 pt-4 text-sm text-muted-foreground">
        <Link to="/" className="hover:text-foreground">
          Home
        </Link>
        <span className="mx-2">/</span>
        <span className="text-foreground">{title}</span>
      </nav>
      <article className="mx-auto max-w-3xl px-4 sm:px-6 py-8 pb-16">
        <h1 className="text-3xl font-bold text-foreground">{title}</h1>
        {intro ? (
          <p className="mt-3 text-base leading-relaxed text-muted-foreground">{intro}</p>
        ) : null}
        <div className="mt-8 space-y-8 text-sm leading-relaxed text-muted-foreground [&_h2]:text-lg [&_h2]:font-bold [&_h2]:text-foreground [&_h2]:mb-2 [&_h3]:font-semibold [&_h3]:text-foreground [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_a]:text-primary [&_a]:underline">
          {children}
        </div>
      </article>
    </div>
  );
}

export function staticHead(opts: {
  title: string;
  description: string;
  path: string;
  noindex?: boolean;
}) {
  const url = `https://autospecdata.com${opts.path}`;
  const meta: Record<string, string>[] = [
    { title: opts.title },
    { name: "description", content: opts.description },
    { property: "og:title", content: opts.title },
    { property: "og:description", content: opts.description },
    { property: "og:url", content: url },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary_large_image" },
    { property: "og:image", content: SITE_OG_IMAGE },
    { name: "twitter:image", content: SITE_OG_IMAGE },
  ];
  if (opts.noindex) meta.push({ name: "robots", content: "noindex, follow" });
  return {
    meta,
    links: [{ rel: "canonical", href: url }],
  };
}
